import { MEDUSA_API_URL, MEDUSA_API_KEY } from './config';

// Reseñas de un producto (público). Trae hasta `limit` reseñas aprobadas + el
// resumen (promedio y distribución) calculado en el backend sobre el total.
export async function fetchProductReviews(productId, { limit = 500, offset = 0, sort = 'recent', rating = 0 } = {}) {
  const params = new URLSearchParams({ limit: String(limit), offset: String(offset), sort });
  if (rating) params.set('rating', String(rating));
  const res = await fetch(`${MEDUSA_API_URL}/store/products/${productId}/reviews?${params.toString()}`, {
    headers: { 'x-publishable-api-key': MEDUSA_API_KEY },
  });
  if (!res.ok) throw new Error(`reviews ${res.status}`);
  return res.json(); // { reviews, summary, filtered_count, limit, offset }
}

// "Link mágico": productos por reseñar de un pedido, identificados por token
// firmado (sin login). Devuelve { customer_name, order_display_id, products }.
export async function fetchReviewsByToken(token) {
  const res = await fetch(`${MEDUSA_API_URL}/store/reviews/by-token?token=${encodeURIComponent(token)}`, {
    headers: { 'x-publishable-api-key': MEDUSA_API_KEY },
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(json.message || `Error ${res.status}`);
    err.status = res.status;
    throw err;
  }
  return json;
}

// "Link mágico": enviar una reseña con el token (sin login). data = { token, product_id, rating, title?, content }.
export async function submitReviewByToken(data) {
  const res = await fetch(`${MEDUSA_API_URL}/store/reviews/by-token`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-publishable-api-key': MEDUSA_API_KEY,
    },
    body: JSON.stringify(data),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(json.message || `Error ${res.status}`);
    err.status = res.status;
    throw err;
  }
  return json;
}

// Enviar una reseña nueva (requiere sesión de cliente + haber comprado el producto).
export async function submitProductReview(productId, data) {
  const res = await fetch(`${MEDUSA_API_URL}/store/products/${productId}/reviews`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-publishable-api-key': MEDUSA_API_KEY,
    },
    body: JSON.stringify(data),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(json.message || `Error ${res.status}`);
    err.status = res.status;
    throw err;
  }
  return json;
}
